import { CAUI } from '../../../ui/2.0/ca-ui';

export class VRAsset {
  static defaultOptions = {
    visible: true,
    yaw: 0,
    pitch: 0,
    allowMove: true
  };

  constructor (vr, scene, options) {
    this.id = options.id ? options.id : (this.id = CAUI.createId());
    this.vr = vr;
    this.scene = scene;
    this.moving = false;
    this.moved = false;
    this.firstRender = true;
    this.allowVisible = true;
    this.isValidTransform = true;

    this.options = $.extend({}, VRAsset.defaultOptions, options);

    this.hasAction = this.options.action != null;

    if (!this.topLeftYawPitch) {
      this.topLeftYawPitch = {
        yaw: this.options.yaw,
        pitch: this.options.pitch
      };
    }

    this.div = $('<div class="ca-vr_asset ca-vr_asset_fadein"></div>');
    if (!this.options.visible) this.div.hide();
    this.div.attr('id', 'ca-vr_asset_' + this.id);
    this.div.attr('draggable', false);

    this.assetContainer = $('<div class="ca-vr_asset_container"></div>');
    if (this.hasAction) this.assetContainer.css('cursor', 'zoom-in');
    this.div.append(this.assetContainer);

    if (this.options.shadow !== false) {
      this.shadow = $('<div class="ca-vr_asset_shadow"></div>');
      this.assetContainer.append(this.shadow);
    }

    if (this.options.allowMove) {
      this.div.mousedown(
        function (event) {
          if (this.vr.isEditing()) {
            event.stopPropagation();

            this.vr.getEditor().select(this);
            this.saveMouseDownState(event);

            this.moving = true;

            this.vr.enableMove(false);
          }
        }.bind(this)
      );
    }

    if (this.hasAction) {
      this.div.on(
        'click',
        function () {
          // eslint-disable-next-line no-useless-return
          if (this.vr.isEditing()) return;
        }.bind(this)
      );
    }
  }

  toggle (show) {
    this.allowVisible = !show;
  }

  show () {
    this.toggle(false);
  }

  hide () {
    this.toggle(true);
  }

  // handles actions consumed from the hotspot from client's config.json
  handleAction (action) {
    if (!action) return;

    if (action.type === 'jumpToScene') {
      this.vr.lookAtOverlay(this, this.vr.getMaxFov(), 400, true);
      // investigate loadscene, its conflicting with US trying to focus on the hotspot
      this.vr.loadScene(action.scene, -this.options.yaw, this.options.pitch);
    } else if (action.type === 'openContent') {
      this.vr.openContent(this.options.action.content);
      this.vr.lookAtOverlay(this, this.vr.getMaxFov(), 400);
    } else if (action.type === 'externalLink') {
      this.vr.logAction('External', 'Opened external link: ' + action.url);
      window.open(action.url, '_blank', null, null);
    } else if (action.type === 'viewPdf') {
      this.vr.logAction(
        'External',
        'Opened external pdf: ' + this.options.action.file
      );
      window.open(this.options.action.file, '_blank', null);
    } else if (action.type === 'popup') {
      // this.vr.openContent(this.options.action.actionInfo.content);
      // this.vr.lookAtOverlay(this, this.vr.getMaxFov(), 400);
      // this.div.unbind();
    }
  }

  render () {
    if (this.firstRender) {
      this.firstRender = false;
      this.onFirstRender();
    }

    this.topLeft = this.vr.yawPitchToPx(
      this.topLeftYawPitch.yaw,
      this.topLeftYawPitch.pitch
    );
    return true;
  }

  layout () {}

  setValidTransform (validTransform) {
    if (!validTransform && this.isValidTransform) {
      this.isValidTransform = false;
      this.div.hide();
    }

    if (validTransform && !this.isValidTransform) {
      this.isValidTransform = true;
      this.div.show();
    }
  }

  onRoomChange (roomOptions) {
    console.log('onRoomChange ' + roomOptions.id);
  }

  onFirstRender () {}

  stopMoving () {
    this.moving = false;
    this.saveMouseDownState();
  }

  moveBy () {
    this.moved = true;
  }

  moveTo (x, y) {
    this.move(x, y);
  }

  move (x, y) {
    this.options.yaw = x;
    this.options.pitch = y;
    this.topLeftYawPitch.yaw = x;
    this.topLeftYawPitch.pitch = y;
  }

  setEditMode (editMode) {
    // console.log('set edit mode called');
    this.editMode = editMode;
    // console.log('setEditMode ' + editMode);

    this.div.toggleClass('edit', editMode);
    if (editMode) {
      this.vr.getEditor().openSubPanel(this);
    } else {
      this.vr.getEditor().closeSubPanel();
    }
  }

  isEditMode () {
    return this.editMode;
  }

  isMoving () {
    return this.moving;
  }

  enable () {}

  saveMouseDownState (event) {
    if (event !== undefined) {
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.mouseDownTopLeftYawPitch = {
        yaw: this.topLeftYawPitch.yaw,
        pitch: this.topLeftYawPitch.pitch
      };
    }
  }

  getTopLeftYawPitch () {
    return this.topLeftYawPitch;
  }
}
